import { ScrollDirection, useScrollDirection } from '@jusbrasil-web/shared-hooks'
import classNames from 'classnames/bind'
import { ReactNode, useEffect, useRef, useState } from 'react'

import styles from './auto-hide-on-scroll.module.scss'

const cx = classNames.bind(styles)

export interface AutoHideOnScrollProps {
  children: ReactNode
  direction?: ScrollDirection
}

export function AutoHideOnScroll(props: AutoHideOnScrollProps) {
  const { children, direction = 'down' } = props

  const scrollDirection = useScrollDirection()
  const refElement = useRef<HTMLSpanElement>(null)
  const [show, setShow] = useState<boolean | undefined>()
  const prevShowRef = useRef<boolean | undefined>(undefined)
  const expectedDirection = scrollDirection === direction
  const hide = !show && !expectedDirection && prevShowRef.current !== undefined

  useEffect(() => {
    if (!('IntersectionObserver' in window) || !refElement.current) return
    const observer = new IntersectionObserver(([e]) => {
      const intersected = e.intersectionRatio < 1
      setShow(intersected ? expectedDirection : undefined)
    })
    observer.observe(refElement.current)
    return () => {
      observer.disconnect()
    }
  }, [refElement, expectedDirection])

  useEffect(() => {
    prevShowRef.current = show
  }, [show])

  return (
    <>
      <span ref={refElement} />
      <div className={cx({ show, hide })}>{children}</div>
    </>
  )
}
